
<div class="container">
  <div class="row mt-3">
    <div class="col-md-2">&nbsp;</div>
    <div class="col-md-8">
      <h5>Partner Account:</h5>
      <error [error]="error"></error>
      <form (ngSubmit)="save()">
        <div class="card-block">
          <div class="form-group" *ngIf="!partnerId">
            <label class="required" for="emailAddress">Email Address</label>
            <input class="form-control" id="emailAddress" [(ngModel)]="partner.emailAddress" type="email" name="uid" required="true" maxlength="60">
          </div>
          <div class="form-group" *ngIf="partnerId">
            <label class="required" for="emailAddressD">Email Address</label>
            <input class="form-control" id="emailAddressD" [value]="partner.emailAddress" type="email" disabled>
          </div>
          <div class="form-group" *ngIf="partnerId">
            <label for="firstName">First Name</label>
            <input class="form-control" id="firstName" type="text" [value]="partner.firstName" disabled>
          </div>
          <div class="form-group" *ngIf="partnerId">
            <label for="lastName">Last Name</label>
            <input class="form-control" id="lastName" type="text" [value]="partner.lastName" disabled>
          </div>
          <div class="form-group">
            <label>Organization</label>
            <input class="form-control" [(ngModel)]="partner.organization" type="text" name="organization">
          </div>
          <div class="form-group">
            <label>Roles</label>
            <select class="form-control" [(ngModel)]="partner.roleIds" name="rolesSelected" multiple>
              <option *ngFor="let role of roles" [ngValue]="role.id">{{ role.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <div class="btn-group float-right"><a class="btn btn-outline-secondary ml-1" [href]="'/#/partners'">Cancel</a>
              <button class="btn btn-primary" type="submit">Save</button>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>